export const UNIQUE_VALUES_LIST = ['HP Champion', 'Partner Signer', 'L&R Champion']

export const TOOLS_REQUIRED_HPID = ['BMI/IQ', 'BMI/IQ One Config', 'BMI/IQ Distributor', 'IQ']

export const SAVE_AS_DRAFT_CONTACT_FORM_KEY = 'saveAsDraftContactForm'
